import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";

const Chapter6_2 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welche Sicherheitsmaßnahme schützt deine Cloud-Daten während der Übertragung und im Ruhezustand?",
      options: [
        {
          value: "A",
          label: "Passwortschutz",
        },
        {
          value: "B",
          label: "Datenverschlüsselung",
        },
      ],
      correct: "B",
    },

    {
      question:
        "Frage 2: Was beschreibt das Shared Responsibility Model in der Cloud?",
      options: [
        {
          value: "A",
          label:
            "Die vollständige Verantwortung des Cloud-Anbieters für alle Sicherheitsaspekte.",
        },
        {
          value: "B",
          label:
            "Die geteilte Verantwortung für Sicherheit zwischen Cloud-Anbieter und Nutzer.",
        },
      ],
      correct: "B",
    },
  ];

 
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 6_2.js:", userId);
  }, [userId]);

  const handleLogout = () => {
   
    auth
      .signOut()
      .then(() => {
      
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

       
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "6_2",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("6_2"),
            });
          console.log("Dokument aktualisiert mit Kapitel 6_2.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "6_2",
              completedChapters: ["6_2"],
            });
          console.log("Dokument erstellt mit Kapitel 6_2");
        }

        navigate("/cybersecurity/6_3"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  5. Sicheres Cloud Computing
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Grundlagen der Cloud-Sicherheit
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 6: Sicheres Cloud Computing
          </h3>
          <h2 className="text-center pb-5">Grundlagen der Cloud-Sicherheit </h2>
          <img
            src="/images/cloudsecurity.webp"
            alt="Cloud-Sicherheit"
            style={{ position: "relative", maxWidth: "25%", height: "auto" }}
          />
        </div>

        <div className="white-section">
          <div className="container p-5">
            <div className="p-5 ">
              <h3 className="p-5">Geteiltes Sicherheitsmodell</h3>
              <p className="col-lg-11 text-center mx-auto">
                Bei der Nutzung von Cloud-Diensten wird die
                Sicherheitsverantwortung zwischen dem Nutzer und dem Cloud-Anbieter
                aufgeteilt. Das{" "}
                <strong>
                  {" "}
                  Shared Responsibility Model (geteilte Verantwortung){" "}
                </strong>{" "}
                definiert, welche Sicherheitsaufgaben der Anbieter und der
                Nutzer übernehmen müssen.
                <br />
                <br /> Grundsätzlich gilt, dass der Cloud-Anbieter für die
                physische Sicherheit der Rechenzentren, die Netzwerksicherheit
                und die Wartung der Infrastruktur verantwortlich ist. Der Nutzer
                ist für alles verantwortlich, was er in der Cloud betreibt –
                von Anwendungen über Daten bis hin zu den Zugriffskontrollen.
                <br />
                <br />
                Die Art und der Umfang seiner Verantwortung hängt jedoch davon
                ab, welchen Cloud-Service er nutzt. Je mehr Kontrolle er über
                die Technologie hat, desto mehr Verantwortung übernimmt er für
                die Sicherheit. <br />
                <br />
                Es gibt drei Service-Modelle:{" "}
                <strong>
                  Infrastructure as a Service (IaaS), Platform as a Service
                  (PaaS) und Software as a Service (SaaS).{" "}
                </strong>{" "}
                Jedes Modell bietet einen unterschiedlichen Grad an Kontrolle und
                Verantwortung.
              </p>
            </div>
          </div>

          <div className="grey-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">Infrastructure as a Service (IaaS)</h3>
                <p className="col-lg-11 mx-auto">
                  IaaS bietet eine grundlegende IT-Infrastruktur wie virtuelle
                  Maschinen, Speicher, Netzwerke und Server, die über das
                  Internet genutzt werden kann. IaaS bietet die{" "}
                  <strong> größte Flexibilität </strong>und wird häufig von
                  Unternehmen genutzt, die maßgeschneiderte Lösungen entwickeln
                  müssen und eine hohe Kontrolle möchten. Sie können ihre
                  Infrastruktur flexibel anpassen und je nach Bedarf skalieren,
                  was besonders für datenintensive Anwendungen von Vorteil ist.
                  <br />
                  <br />
                  Beispiel: Der Nutzer mietet virtuelle Server auf AWS (Amazon Web Services) und installiert
                  sein eigenes Betriebssystem sowie Software. Da er die volle
                  Kontrolle über die Infrastruktur hat, muss er alle wichtigen
                  Sicherheitsmaßnahmen selbst implementieren – von der
                  Netzwerksicherheit über Betriebssystem-Updates bis hin zur
                  Verwaltung seiner Daten. Der Anbieter kümmert sich in diesem
                  Modell nur um die physische Infrastruktur und Visualisierung.
                </p>

                <div class="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 g-3 p-5">
                  <div class="col d-flex align-items-start">
                    <div class="p-3">
                      <h5 className="pt-3">
                        {" "}
                        <strong>
                          Sicherheitsverantwortlichkeiten des Anbieters:
                        </strong>
                      </h5>
                      <p className="col-lg-11 text-start mx-auto">
                        <ul>
                          <li>Physische Sicherheit der Rechenzentren</li>
                          <li>
                            Netzwerksicherheit und Wartung der virtuelle
                            Netzwerkelemente{" "}
                          </li>
                          <li>
                            Netzwerksicherheit auf Infrastrukturebene, (z. B.
                            Firewalls )
                          </li>
                        </ul>
                      </p>
                    </div>
                  </div>
                  <div class="col d-flex align-items-start">
                    <div class="p-3">
                      <h5 className="pt-3">
                        {" "}
                        <strong>
                          {" "}
                          Sicherheitsverantwortlichkeiten des Nutzers:
                        </strong>
                      </h5>
                      <p className="col-lg-11 text-start mx-auto">
                        <ul>
                          <li>
                            Sicherheit der Betriebssysteme und Anwendungen
                          </li>
                          <li>Patch-Management und Konfiguration</li>
                          <li>
                            Konfiguration von Zugriffskontrollen und
                            Berechtigungen
                          </li>
                          <li>Datenverschlüsselung und Zugriffskontrollen</li>
                          <li>
                            Sicherheitsüberwachung und Schutz der
                            Anwendungsdaten
                          </li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Große Konzerne oder Unternehmen mit starkem Datenwachstum, wie
                  zum Beispiel Streaming-Plattformen oder Finanzinstitute,
                  nutzen IaaS-Dienste wie Amazon Web Services (AWS) oder
                  Microsoft Azure für den Betrieb virtueller Server,
                  Speichersysteme und Netzwerke.
                </p>
              </div>
            </div>
          </div>

          <div className="gelb-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">Platform as a Service (PaaS)</h3>
                <p className="col-lg-11 mx-auto">
                  PaaS ist ideal für Entwickler, die Anwendungen erstellen
                  wollen, ohne sich um die zugrunde liegende Infrastruktur zu
                  kümmern. Der Anbieter verwaltet Server, Betriebssysteme und
                  Netzwerke, sodass der Nutzer sich auf die Programmierung und die
                  Anwendungslogik fokussieren kann.
                  <br />
                  <br />
                  Beispiel: Mit Google App Engine oder Microsoft Azure App
                  Service kann man seinen eigenen Code hochladen, und Google oder
                  Microsoft kümmern sich um die Bereitstellung und Skalierung.
                </p>

                <div class="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 g-3 p-5">
                  <div class="col d-flex align-items-start">
                    <div class="p-3">
                      <h5 className="pt-3">
                        {" "}
                        <strong>
                          Sicherheitsverantwortlichkeiten des Anbieters:
                        </strong>
                      </h5>
                      <p className="col-lg-11  mx-auto">
                        Betriebssystem, Laufzeitumgebung und{" "}
                        <span
                          data-tooltip-id="tooltip-midd"
                          data-tooltip-content="Middleware ist eine Vermittlungsschicht zwischen Betriebssystem und Anwendungen, die verschiedene Softwarekomponenten oder Systeme miteinander verbindet. Sie stellt Dienste und Funktionen bereit, die Anwendungen benötigen, aber nicht selbst implementieren müssen."
                          className="custom-tooltip-trigger"
                        >
                          {" "}
                          Middleware{" "}
                        </span>{" "}
                        werden vom Anbieter verwaltet.
                      </p>
                      <ReactTooltip
                        id="tooltip-midd"
                        place="top"
                        className="custom-tooltip"
                      />
                    </div>
                  </div>
                  <div class="col d-flex align-items-start">
                    <div class="p-3">
                      <h5 className="pt-3">
                        {" "}
                        <strong>
                          Sicherheitsverantwortlichkeiten des Nutzers:
                        </strong>
                      </h5>
                      <p className="col-lg-11  mx-auto">
                        Du bist verantwortlich für die Sicherheit deines Codes,
                        die Verwaltung von Zugriffen (IAM),{" "}
                        <span
                          data-tooltip-id="tooltip-api"
                          data-tooltip-content="Eine API (Application Programming Interface) ist eine Schnittstelle, die es verschiedenen Softwareanwendungen ermöglicht, miteinander zu kommunizieren und Daten auszutauschen, indem sie definierte Regeln und Protokolle für die Interaktion bereitstellt."
                          className="custom-tooltip-trigger"
                        >
                          {" "}
                          API-Sicherheit{" "}
                        </span>{" "}
                        und die Verschlüsselung der Daten, die von deinem Code
                        verarbeitet werden.
                      </p>
                    </div>
                  </div>
                </div>

                <p className="col-lg-9 mx-auto d-inline-flex p-5  text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Softwareentwicklungsunternehmen oder große IT-Teams, die ihre
                  eigenen Anwendungen erstellen und verwalten möchten, nutzen
                  oft PaaS-Dienste wie Google App Engine oder Microsoft Azure
                  App Service.
                </p>
              </div>
            </div>
          </div>

          <div className="grey-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">Software as a Service (SaaS)</h3>
                <p className="col-lg-11 mx-auto">
                  SaaS bietet eine{" "}
                  <strong> komplette und fertige Softwarelösung, </strong> ohne
                  dass etwas zu installieren oder zu konfigurieren ist. Dateien
                  werden online gespeichert und synchronisiert, sodass sie von
                  überall abrufbar sind. Der Nutzer muss sich nicht um die
                  Wartung der Anwendung oder der Infrastruktur kümmern – der
                  Anbieter übernimmt diese Aufgaben. SaaS ist ideal für
                  Endbenutzer, die sofort einsatzbereite Anwendungen benötigen,
                  wie CRM-Systeme oder Buchhaltungssoftware.
                  <br />
                  <br /> Beispiel: Ein Unternehmen nutzt die Dropbox für
                  Cloud-Speicher und Dateifreigabe als fertige Anwendung.
                </p>

                <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 g-3 p-5">
                  <div class="col d-flex align-items-start">
                    <div class="p-3">
                      <h5 className="pt-3">
                        {" "}
                        <strong>
                          Sicherheitsverantwortlichkeiten des Anbieters:
                        </strong>
                      </h5>
                      <p className="col-lg-11 text-start mx-auto">
                        <ul>
                          <li>
                            Infrastruktursicherheit (Schutz der Server,
                            Firewalls, physische Sicherheit der Rechenzentren).
                          </li>
                          <li>Datenverschlüsselung</li>
                          <li>Updates und Patches</li>
                          <li>Verfügbarkeit (Redundanz und Backups).</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                  <div class="col d-flex align-items-start">
                    <div class="p-3">
                      <h5 className="pt-3">
                        {" "}
                        <strong>
                          Sicherheitsverantwortlichkeiten des Nutzers:
                        </strong>
                      </h5>
                      <p className="col-lg-11 text-start mx-auto">
                        <ul>
                          <li>
                            Dateien und Ordner sollten nicht öffentlich oder für
                            falsche Personen freigegeben werden.
                          </li>
                          <li>
                            Nutzer müssen sichere Passwörter verwenden und MFA
                            aktivieren, um unbefugten Zugriff zu verhindern.
                          </li>
                          <li>
                            Durch Zugriffskontrollen kann man überprüfen, wer Zugriff auf
                            welche Daten hat.{" "}
                          </li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Kleine und mittlere Unternehmen (KMU), die keine eigene
                  IT-Infrastruktur für Anwendungen bereitstellen möchten, nutzen
                  SaaS-Lösungen wie die Dropbox, Salesforce für CRM, Microsoft
                  365 für Office-Produktivität oder Slack für Kommunikation.
                  KMUs können auf umfassende Softwarelösungen zugreifen, ohne
                  Hardware oder Software zu installieren oder zu warten. Das
                  spart Zeit und Kosten, da die Anwendung vollständig vom
                  Anbieter verwaltet wird.
                </p>
              </div>
            </div>
          </div>

          <div className="white-section">
            <div className="container p-5">
              <h2 className="p-5">
                Verschlüsselung von Daten im Cloud-Computing
              </h2>
              <p className="col-lg-11 mx-auto">
                Verschlüsselung von Daten in der Cloud unterscheidet sich in
                einigen Punkten von der Verschlüsselung in der
                Netzwerksicherheit, da Cloud-Daten nicht nur{" "}
                <strong>während der Übertragung, </strong> sondern auch{" "}
                <strong>im Ruhezustand </strong> und{" "}
                <strong> bei der Verarbeitung </strong> geschützt werden müssen.
              </p>
              <h4 className="p-5"> Daten in Ruhe (At Rest) </h4>
              <p className="col-lg-11 mx-auto">
                Daten befinden sich „in Ruhe“, wenn sie in Datenbanken,
                Dateispeichern oder Cloud-Speicherdiensten abgelegt sind, ohne
                aktiv übertragen oder verarbeitet zu werden. In diesem Zustand
                müssen sie gegen unbefugten Zugriff und physische Diebstähle
                geschützt werden, da Speichermedien kompromittiert werden
                können.
              </p>
              <h5 className="p-3">Schutzmaßnahmen:</h5>
              <p className="col-lg-11 text-start mx-auto">
                <ul>
                  <li>
                    Verschlüsselung gespeicherter Daten mit{" "}
                    <strong>Advanced Encryption Standard </strong> mit 256 Bit
                    Schlüssellänge. Diese Verschlüsselungsmethode gilt als
                    sicher und wird von Cloud-Anbietern standardmäßig
                    eingesetzt.{" "}
                  </li>
                  <br />
                  <li>
                    <strong>HSM (Hardware Security Module) </strong> für
                    Schlüsselverwaltung. HSM sind spezialisierte
                    Hardwaregeräte, die Kryptografieschlüssel sicher speichern
                    und verwalten, um den Zugriff durch unbefugte Dritte zu
                    verhindern.
                  </li>
                  <br />
                  <li>
                    Möglichkeit eines{" "}
                    <strong> Cloud-eigenen Schlüsselmanagements. </strong> Hier
                    verwaltet der Cloud-Provider die Schlüssel.{" "}
                  </li>
                </ul>{" "}
                <br /> <br />
              </p>
              <h4 className="p-5">
                Daten während der Übertragung (In Transit)
              </h4>
              <p className="col-lg-11 mx-auto">
                Daten befinden sich „in Übertragung“, wenn sie zwischen
                Cloud-Servern, Endgeräten, Rechenzentren oder Anwendungen
                ausgetauscht werden. Dieser Zustand ist besonders anfällig für
                Man-in-the-Middle (MITM)-Angriffe.
              </p>
              <h5 className="p-3">Schutzmaßnahmen:</h5>{" "}
              <p className="col-lg-11 text-start mx-auto">
                <ul>
                  <li>
                    <strong>Transportverschlüsselung </strong> durch Protokolle
                    wie TLS (Transport Layer Security) oder SSL (Secure Sockets
                    Layer).
                  </li>
                  <br />
                  <li>
                    <strong>Ende-zu-Ende-Verschlüsselung </strong> für maximale
                    Sicherheit. Dabei werden die Daten bereits vor der
                    Übertragung auf dem Endgerät verschlüsselt und erst am Ziel
                    entschlüsselt.
                  </li>
                  <br />
                  <li>
                    <strong>DLP (Data Loss Prevention) </strong> zur Erkennung
                    sensibler Datenübertragungen. Dabei scannen
                    Cloud-DLP-Dienste den ausgehenden Datenverkehr, um
                    versehentliche Leaks oder unautorisierten Zugriff zu
                    verhindern.
                  </li>
                </ul>
                <br /> <br />
              </p>
              <h4 className="p-5">Daten während der Verarbeitung (In Use)</h4>
              <p className="col-lg-11 mx-auto">
                Daten befinden sich im Zustand „während der Verarbeitung“, wenn sie in RAM,
                CPU oder im Speicher eines Servers genutzt werden. Während
                ruhende und übertragene Daten relativ gut geschützt sind, bleibt
                die Sicherheit während der Verarbeitung eine Herausforderung,
                weil Daten im Klartext verarbeitet werden müssen.
              </p>
              <h5 className="p-3">Schutzmaßnahmen:</h5>
              <p className="col-lg-11 text-start mx-auto">
                <ul>
                  <li>
                    <strong>Homomorphe Verschlüsselung </strong> ermöglicht es,
                    Daten zu verarbeiten, ohne sie zu entschlüsseln. Vor allem
                    numerische Bearbeitungen können dabei direkt mit
                    verschlüsselten Daten durchgeführt werden. Das Ergebnis
                    ist nach der Entschlüsselung dasselbe, als hätte man die
                    Berechnung mit unverschlüsselten Daten gemacht. Diese
                    Methode wird im Gesundheitsbereich oder im Finanzwesen
                    genutzt.
                  </li>
                  <br />

                  <li>
                    <strong>Speicherverschlüsselung </strong> bei denen unverschlüsselte Daten aus dem
                    Speicher ausgelesen werden. Es gibt die Möglichkeit, den
                    kompletten Arbeitsspeicher zu verschlüsseln (z. B. Intel Total
                    Memory Encryption) oder nur die Daten, die sich im RAM
                    befinden, isoliert und geschützt zu bearbeiten (z. B. AWS
                    Nitro Enclaves).
                  </li>
                </ul>
              </p>
            </div>
          </div>

          <div className="container p-5">
            <div
              className="safe rounded-2 text-center"
              style={{ backgroundColor: "#fec748" }}
            >
              <img
                src="/images/abwehr.svg"
                alt="Abwehr"
                style={{
                  position: "relative",
                  maxWidth: "7%",
                  height: "auto",
                }}
              />
              <h3 className="p-5">Identitäts- und Zugriffsmanagement (IAM)</h3>
              <p className="col-lg-11 mx-auto">
                Das Identitäts- und Zugriffsmanagement
                <Link to="/cybersecurity/1_4#iam" className="icon-link">
                  <svg className="bi" aria-hidden="true">
                    <use xlinkHref="#book"></use>
                  </svg>{" "}
                  (IAM)
                </Link>{" "}
                ist ein Kernstück der Cloud-Sicherheit. Es stellt sicher, dass
                nur autorisierte Personen und Systeme auf die Cloud-Ressourcen
                zugreifen können und legt ihre Berechtigungen fest.
                <br /><br />
                <strong>Identitäten verwalten: </strong>
                Jeder Benutzer oder jedes System, das auf die Cloud zugreift,
                benötigt eine eindeutige Identität. IAM hilft, diese Identitäten
                zu erstellen, zu verwalten und zu authentifizieren.
                <br />
                <br />
                <strong>Zugriffsrechte zuweisen: </strong>
                Mit IAM werden rollenbasierte Zugriffskontrollen (RBAC)
                implementiert. Dabei werden Benutzern basierend auf ihrer Rolle
                (z. B. Administrator oder normaler Nutzer) spezifische Rechte
                zugewiesen.
                <br />
                <br />{" "}
                <Link to="/cybersecurity/2_3#mfa" className="icon-link">
                  <svg className="bi" aria-hidden="true">
                    <use xlinkHref="#book"></use>
                  </svg>{" "}
                  Multi-Faktor-Authentifizierung (MFA):
                </Link>{" "}
                MFA fügt eine zusätzliche Sicherheitsebene hinzu, indem neben
                dem Passwort ein zweiter Faktor wie ein Code auf dem Smartphone
                abgefragt wird. Dies erschwert unbefugten Zugriff erheblich.
              </p>
              <h5 className="pt-5">
                <strong>Best Practices beim IAM:</strong>
              </h5>
              <p className="p-3 col-lg-10 text-start mx-auto">
                <section class="pt-5 text-start">
                  <ul class="timeline">
                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">
                        Prinzip der minimalen Berechtigungen (Least Privilege):
                      </h5>

                      <p>
                        Benutzern nur die minimalen Zugriffsrechte erteilen, die
                        für die Ausführung ihrer Aufgaben erforderlich sind.
                        Dies minimiert das Risiko von Missbrauch und ungewolltem
                        Zugriff auf sensible Daten.
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">
                        Multi-Faktor-Authentifizierung (MFA):
                      </h5>

                      <p>
                        MFA für alle Benutzer implementieren, insbesondere für
                        Administratoren, um eine zusätzliche Sicherheitsebene zu
                        schaffen und unbefugte Zugriffe zu erschweren.
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">
                        Rollenbasierte Zugriffskontrollen (RBAC):
                      </h5>

                      <p>
                        Rechte über rollenbasierte Zugriffskontrollen definieren
                        und spezifische Rollen zuweisen. Dies reduziert den
                        Verwaltungsaufwand und gewährleistet eine bessere
                        Übersicht über Zugriffsrechte.
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">
                        Lifecycle-Management von Benutzerkonten:
                      </h5>

                      <p>
                        Benutzerkonten automatisch erstellen und löschen, wenn
                        Mitarbeiter ein- oder austreten. Regelmäßige
                        Überprüfungen der bestehenden Berechtigungen
                        durchführen, um sicherzustellen, dass nur aktive
                        Benutzer auf Ressourcen zugreifen.
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">Monitoring und Protokollierung:</h5>

                      <p>
                        Zugriffsversuche auf Cloud-Ressourcen überwachen und
                        verdächtige Aktivitäten, wie viele fehlgeschlagene
                        Anmeldeversuche, protokollieren und benachrichtigen
                        lassen. Dienste wie AWS CloudTrail bieten detaillierte
                        Protokollierungsfunktionen.
                      </p>
                    </li>
                    <li class="timeline-item mb-5">
                      <h5>
                        <Link to="/cybersecurity/2_3" className="icon-link">
                          {" "}
                          <svg className="bi" aria-hidden="true">
                            {" "}
                            <use xlinkHref="#book"></use>{" "}
                          </svg>{" "}
                          Starke Passwortrichtlinien:{" "}
                        </Link>{" "}
                      </h5>

                      <p>
                        Richtlinien mit Mindestanforderungen wie Passwortlänge,
                        regelmäßigen Updates und dem Verbot der Wiederverwendung
                        alter Passwörter umsetzen. Dadurch wird das Risiko 
                        schwacher oder wiederverwendeter Passwörter minimiert.
                      </p>
                    </li>
                  </ul>
                </section>
              </p>

              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Laut einem Bericht von Gartner (2021) sind über 90% der
                Cloud-Sicherheitsvorfälle nicht auf Sicherheitslücken in der
                Cloud selbst zurückzuführen, sondern auf Fehlkonfigurationen
                durch Benutzer – oft im Bereich IAM. Das bedeutet, dass
                Sicherheitsverletzungen häufig auf zu großzügige Berechtigungen,
                mangelnde Multi-Faktor-Authentifizierung oder schlecht
                verwaltete Zugriffskontrollen zurückzuführen sind.
              </p>
            </div>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter6_2;
